import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import Swal from 'sweetalert2';
import { AuthService } from '../../auth/auth.service';
import { Router } from '@angular/router';
import { messages } from '../../elements/funciones/mensajes';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css'
})
export class ForgotPasswordComponent {
  #auth = inject(AuthService);
  #router = inject(Router);
  
  formForgotPass = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  });
  
  async forgotPass(){
    if(this.formForgotPass.valid){
      const email = (this.formForgotPass.controls['email'].value).toLowerCase();
      await firstValueFrom(this.#auth.forgotPassword(email));
      messages.infoMessageGraph('En caso de que la dirección de correo electrónico ingresada '+
          'se encuentre registrado en nuestro sistema, se enviará un correo con'+
          ' las instrucciones para recuperar la contraseña');
    }
  }
}
